var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('dashboard',{attrs:{"keycloak":_vm.keycloak}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }